import { randomString } from '../utils/strings';
export const STORAGE_DEVICE_ID_KEY = 'CTV_FRAMEWORK_DEVICE_ID';
const ID_LENGTH = 20;
export class DeviceInfo {
    cache;
    deviceBrand = '';
    deviceManufacturer = '';
    deviceFirmware = '';
    deviceModel = '';
    deviceFullModel = '';
    deviceType = 'Unknown';
    deviceVersion = '';
    deviceFullVersion = '';
    partnerId = '';
    operatingSystemName = '';
    operatingSystemVersion = '';
    browserName = '';
    browserVersion = '';
    userFriendlyName = '';
    frameworkName = '';
    frameworkVersion = '';
    containerVersion = '';
    deviceChipset = '';
    cachedDeviceId = '';
    constructor(cache) {
        this.cache = cache;
    }
    initialise() {
        return this.cache.getItem(STORAGE_DEVICE_ID_KEY).then((cachedId) => this.cacheDeviceId(cachedId));
    }
    get uniqueDeviceId() {
        return this.cachedDeviceId;
    }
    set uniqueDeviceId(value) {
        this.cachedDeviceId = value;
        this.cache.setItem(STORAGE_DEVICE_ID_KEY, value);
    }
    cacheDeviceId(cachedId) {
        if (!cachedId) {
            this.cachedDeviceId = randomString(ID_LENGTH);
            this.cache.setItem(STORAGE_DEVICE_ID_KEY, this.cachedDeviceId);
        }
        else {
            this.cachedDeviceId = cachedId;
        }
        return this.cachedDeviceId;
    }
}
//# sourceMappingURL=device-info.js.map